import { configureStore } from "@reduxjs/toolkit";
import languageReducer from "./languageSlice";
import masterDataReducer from "./Masterdata";

export const store = configureStore({
  reducer: {
    language: languageReducer,
    masterData: masterDataReducer,
  },
});